import GitHubIcon from '@mui/icons-material/GitHub'
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import TwitterIcon from '@mui/icons-material/Twitter';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TelegramIcon from '@mui/icons-material/Telegram';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import { about } from '../../portfolio'
import './About.css'

const About = () => {
  // const { name, role, description, resume, social } = about
  const { name, role, social } = about


  return (
    <div className='about center'>
      {name && (
        <h1>
          Hi, I am <span className='about__name'>{name}</span>
        </h1>
      )}

      {role && <h2 className='about__role'>{role}</h2>}
      <p className='about__desc'>
        🚀 My offer: Smart contract, Trading bot, Website, DApp<br />
        ✔ Blockchain, Fullstack<br />
        🪙Coinbase: Solana, EVM, Bitcoin<br />
        👍 Top skills: Smart contract, Bot, Backend
      </p>

      <div className='about__contact center'>
        {/* {resume && (
          <a href={resume}>
            <span type='button' className='btn btn--outline'>
              Resume
            </span>
          </a>
        )} */}

        {social && (
          <>
            {social.gmail && (
              <a
                href={social.gmail}
                aria-label='gmail'
                className='link link--icon'
              >
                <MailOutlineRoundedIcon />
              </a>
            )}
            {social.github && (
              <a
                href={social.github}
                aria-label='github'
                className='link link--icon'
              >
                <GitHubIcon />
              </a>
            )}

            {social.linkedin && (
              <a
                href={social.linkedin}
                aria-label='linkedin'
                className='link link--icon'
              >
                <LinkedInIcon />
              </a>
            )}

            {social.whatsapp && (
              <a
                href={social.whatsapp}
                aria-label='whatsapp'
                className='link link--icon'
              >
                <WhatsAppIcon />
              </a>
            )}

            {social.discord && (
              <a
                href={social.discord}
                aria-label='discord'
                className='link link--icon'
              >
                <SportsEsportsIcon />
              </a>
            )}

            {social.telegram && (
              <a
                href={social.telegram}
                aria-label='telegram'
                className='link link--icon'
              >
                <TelegramIcon />
              </a>
            )}

            {social.twitter && (
              <a
                href={social.twitter}
                aria-label='twitter'
                className='link link--icon'
              >
                <TwitterIcon />
              </a>
            )}

            {social.instagram && (
              <a
                href={social.instagram}
                aria-label='instagram'
                className='link link--icon'
              >
                <InstagramIcon />
              </a>
            )}

            {social.youtube && (
              <a
                href={social.youtube}
                aria-label='youtube'
                className='link link--icon'
              >
                <YouTubeIcon />
              </a>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default About
